<template>
  <div id="driverActivityChartId">
    <v-overlay :value="loading" :absolute="true">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <v-layout class="pb-1 pt-1">
      <v-flex xs4 md6 class="text-right">
        <v-btn small @click="prevDay"><v-icon small>mdi-chevron-left</v-icon></v-btn>
      </v-flex>
      <v-flex xs4 md2 class="text-center pt-1">
        {{curDate}}
      </v-flex>
      <v-flex xs4 md6 class="text-left">
        <v-btn small @click="nextDay" :disabled="offset === 0"><v-icon small>mdi-chevron-right</v-icon></v-btn>
      </v-flex>
    </v-layout>

    <v-layout align-center justify-center>
      <v-flex class="offset-xl-1" style="max-width:1250px; overflow-x: auto;">
        <div :style="chartBgStyle">
          <DriverHOSChart :dataArray="series" :labels="labelsData" :height="height" :key="hosChartUpdateKey" title=""/>
        </div>
      </v-flex>
      <v-flex class="pa-2 text-left" style="min-height: 220px;">
        <v-chip color="#666666" class="white--text mt-5">
          {{totals[3]}}
          <v-avatar right class="white">
            <span class="black--text">Off</span>
          </v-avatar>
        </v-chip>
        <br/>
        <v-chip color="#ba68c8" class="white--text mt-4">
          {{totals[2]}}
          <v-avatar right class="white">
            <span class="black--text">SB</span>
          </v-avatar>
        </v-chip>
        <br/>
        <v-chip color="#4caf50" class="white--text mt-4">
          {{totals[1]}}
          <v-avatar right class="white">
            <span class="black--text">D</span>
          </v-avatar>
        </v-chip>
        <br/>
        <v-chip color="#2196f3" class="white--text mt-4">
          {{totals[0]}}
          <v-avatar right class="white">
            <span class="black--text">On</span>
          </v-avatar>
        </v-chip>
      </v-flex>
    </v-layout>
    <br/>
    <!-- <canvas id="driverActivityChartCanvasId" width="1200" height="400" style="border: 1px solid #ccc; border-radius: 5px;"></canvas> -->
  </div>
</template>

<script>
import DriverHOSChart from './DriverHOSChart';
import chartsMixin from '../mixins/chartsMixin';

export default {
  name: 'DriverActivityChart',
  props: ['driverId', 'height'],
  components: { DriverHOSChart },
  mixins: [chartsMixin],
  data: function () {
    return {
      loading: true,
      polling: null,
      offset: 0,
      curDate: '',
      totals: [0, 0, 0, 0],
      hosChartUpdateKey: 'hosChartUpdateKey',
      labelsData: [],
      series: [{ data: [] }, { data: [] }, { data: [] }, { data: [] }, { data: [] }],
      chartBgStyle: {
        minWidth: '1238px',
        maxWidth: '1238px',
        minHeight: '220px',
        maxHeight: '220px',
        backgroundPosition: '38px 20px',
        backgroundSize: '1200px 200px',
        backgroundRepeat: 'no-repeat',
        backgroundImage: 'url(' + process.env.BASE_URL + 'img/driver_chart_bg.png)',
        context: null
      }
    };
  },
  mounted () {
    if (this.offsetProp) {
      this.offset = this.offsetProp;
    }
    this.fetchData();
    this.polling = setInterval(() => {
      // Do not call interval methods if page not visible
      if (!this.$store.getters.isPageVisible) return;
      this.fetchData();
    }, 5 * 60 * 1000);
    //this.context = document.getElementById('driverActivityChartCanvasId').getContext('2d');
  },
  beforeDestroy () {
    clearInterval(this.polling);
  },
  methods: {
    nextDay () {
      if (this.offset > 0) {
        this.offset--;
        this.fetchData();
      }
    },
    prevDay () {
      this.offset++;
      this.fetchData();
    },
    fetchData () {
      if (this.driverId) {
        this.loading = true;
        this.$root.getDriverActivity(this.driverId, this.offset).then((response) => {
          if (response.status === 'ok') {
            /*
                            tip
                            if (keeptruckindata.duty_status === "sleeper") statusID = 3;
                            if (keeptruckindata.duty_status === "off_duty") statusID = 4;
                            if (keeptruckindata.duty_status === "on_duty") statusID = 1;
                            if (keeptruckindata.duty_status === "driving") statusID = 2;
                            * */

            this.curDate = response.date;

            const onDutyTime = this.$root.secondsToHms(response.result.series.filter((item) => { return item === 1; }).length * 5 * 60);
            this.$set(this.totals, 0, String(onDutyTime.hours).padStart(2, '0') + ':' + String(onDutyTime.minutes).padStart(2, '0'));

            const sleeperTime = this.$root.secondsToHms(response.result.series.filter((item) => { return item === 3; }).length * 5 * 60);
            this.$set(this.totals, 2, String(sleeperTime.hours).padStart(2, '0') + ':' + new String(sleeperTime.minutes).padStart(2, '0'));

            const drivingTime = this.$root.secondsToHms(response.result.series.filter((item) => { return item === 2; }).length * 5 * 60);

            this.$set(this.totals, 1, String(drivingTime.hours).padStart(2, '0') + ':' + String(drivingTime.minutes).padStart(2, '0'));

            const offDutyTime = this.$root.secondsToHms(response.result.series.filter((item) => { return item === 4; }).length * 5 * 60);
            this.$set(this.totals, 3, String(offDutyTime.hours).padStart(2, '0') + ':' + String(offDutyTime.minutes).padStart(2, '0'));

            this.labelsData = response.result.labels;
            this.series[0].data = response.result.series.map((item) => { return item === 1 ? 1 : null; });
            this.series[1].data = response.result.series.map((item) => { return item === 2 ? 2 : null; });
            this.series[2].data = response.result.series.map((item) => { return item === 3 ? 3 : null; });
            this.series[3].data = response.result.series.map((item) => { return item === 4 ? 4 : null; });
            this.series[4].data = response.result.series

            // let y_map = {3: 50, 2: 150, 1: 250, 0: 350};

            // this.context.clearRect(0,0,1200,400);

            // for(let i = 0; i < 12; i++) {
            //   let x = i * 100;
            //   this.context.lineWidth = 1;
            //   this.context.strokeStyle = "#666666";
            //   this.context.beginPath();
            //   this.context.moveTo(x, 0);
            //   this.context.lineTo(x, 400);
            //   this.context.stroke();
            //   for(let j = 1; j < 4; j++) {
            //     this.context.strokeStyle = "#cccccc";
            //     this.context.lineWidth = 0.5;
            //     this.context.beginPath();
            //     this.context.moveTo(x + j * 25, 0);
            //     this.context.lineTo(x + j * 25, 400);
            //     this.context.stroke();
            //   }
            // }

            // for(let i = 0; i < 4; i++) {
            //   this.context.strokeStyle = "#666666";
            //   this.context.lineWidth = 1;
            //   this.context.beginPath();
            //   this.context.moveTo(0, i * 100);
            //   this.context.lineTo(1200, i * 100);
            //   this.context.stroke();
            // }

            // this.context.strokeStyle = "#0F0";
            // this.context.lineWidth = 10;

            // if (response.result.series[0] >= 0) {
            //   this.context.beginPath();
            //   this.context.moveTo(0, y_map[response.result.series[0]]);
            //   for (let i = 1; i < response.result.series.length; i++) {
            //     if (response.result.series[i] >= 0) {
            //       this.context.lineTo(i * (100 / 12), y_map[response.result.series[i]]);
            //     }
            //   }
            //   this.context.stroke();
            // }

            this.hosChartUpdateKey = 'hosChartUpdateKey' + new Date().getTime()

            this.loading = false;
          }
        });
      }
    }
  }
};
</script>
